import { render } from "./MissingContribution.vue?vue&type=template&id=3392ac1b&ts=true"
import script from "./MissingContribution.vue?vue&type=script&lang=ts"
export * from "./MissingContribution.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__